export default __webpack_public_path__ + "static/media/LMG.967fb3be.png";